import script from "./FormCharactersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCharactersComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormCharactersComponent.vue?vue&type=style&index=0&id=74570347&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74570347"]])

export default __exports__